module.exports = __webpack_public_path__ + "static/img/cruelty_child.99750eff.png";